import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/en-au';
import StatsList from '../../components/Activity/StatsList';
import StatTitleLink from '../../components/Activity/StatTitleLink';
import {
  selectQuizStatsData,
  selectHasLoadedQuizStatsData,
} from '../../lib/store/selectors/activity';
import { GQL_STATISTICS_CONTENT_TYPE } from '../../lib/constants';
import { useGetStats } from './useGetStats';

moment.locale('en-au');

function Quizzes({ stats, hasLoaded }) {
  const { fetchStats, loading } = useGetStats({
    type: GQL_STATISTICS_CONTENT_TYPE.quizzes,
  });

  React.useEffect(() => {
    if (!hasLoaded) {
      const thirtyDaysAgo = moment().subtract(1, 'month').startOf('day');
      fetchStats(thirtyDaysAgo.toISOString());
    }
  }, [hasLoaded]);

  const renderRowTitle = (folderId, folderName) => {
    if (folderName === 'Unknown (DELETED)') return folderName;
    return (
      <StatTitleLink link={'quizzes'} linkText={folderName} titleType="Quiz" />
    );
  };

  const refreshData = () => {
    const thirtyDaysAgo = moment().subtract(1, 'month').startOf('day');
    fetchStats(thirtyDaysAgo.toISOString());
  };

  return (
    <StatsList
      stats={stats}
      isLoading={loading}
      renderRowTitle={renderRowTitle}
      onClickRefresh={refreshData}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    stats: selectQuizStatsData(state),
    hasLoaded: selectHasLoadedQuizStatsData(state),
  };
};

export default connect(mapStateToProps)(Quizzes);
